import { getButtonAnalytics } from "@lib-shared/lib/get-analytics-tags";
import { Button } from "@shared/components/form";
import { getStatusText } from "core/lib/get-status-text";
import { Installation } from "core/models/installation-response";

type InstallationCardProps = {
    installation: Installation,
    onSelect: (installation: Installation) => void,
}

const InstallationCard = (props: InstallationCardProps) => {
    const { installation, onSelect } = props;

    if (!installation?.subscriberDetails) {
        return null;
    }

    const address = installation.subscriberDetails.genericAddress;

    let date = "";
    let time = "";

    if (installation.appointment) {
        const dateParts = installation.appointment.split(" ");
        date = dateParts[0];
        time = dateParts[1];
    }

    const status = getStatusText(installation.state);

    const analytics = getButtonAnalytics("", "View");

    return (<li>
        <p>
            <strong>Reference: <b>{installation.customer_ref}</b></strong>
        </p>

        <address>
            {address}
        </address>

        <dl>
            <dt>Installation Date:</dt>
            <dd>{date || "-"}</dd>

            <dt>Time:</dt>
            <dd>{time || "-"}</dd>

            <dt>Status:</dt>
            <dd>{status || "-"}</dd>
        </dl>

        <Button
            colour="primary"
            text="View"
            onClick={() => onSelect(installation)}
            {...analytics}
            className="btn-small" />
    </li>);
}

export default InstallationCard;
